import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import apiConfig from 'constants/apiConfig';

type GetPermissionsResponse = {
  id: string;
  title: string;
  description: string;
  action: string;
};

const keys = {
  base: ['permissions'] as const,
};

export const useGetPermissions = () => {
  return useQuery({
    queryKey: [keys.base],
    queryFn: async () => {
      const response = await axios.post<GetPermissionsResponse[]>(
        `${apiConfig.apiGateway.fetchAllPermissions}`
      );
      return response.data;
    },
    staleTime: 0,
  });
};
